<template>
  <v-list>
    <v-list-item
      value="true"
      v-for="(item, i) in survey_question_types"
      :key="i"
      @click="$emit('select', item.id)"
    >
      <v-list-item-icon>
        <v-icon
          :color="getQuestionTypeColor(item.id)"
          v-text="getQuestionTypeIcon(item.id)"
        ></v-icon>
      </v-list-item-icon>
      <v-list-item-title
        v-bind:style="{
          color: getQuestionTypeColor(item.id)
        }"
        class="text-h6"
      >
        {{ item.name }}
      </v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapGetters } from "vuex";
import questionTypes from "@/helpers/mixins/questionTypes";
export default {
  name: "SurveyQuestionTypeList",
  components: {},
  mixins: [questionTypes],
  data: () => ({}),
  computed: mapGetters({
    survey_question_types: "lookup/survey_question_types"
  })
};
</script>
